import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { AxiosResponse } from "axios";
import React, { useEffect, useState } from "react";
import { GetPartialRejectedOrdersById } from "Services/BloodPartialRejectedTest";
import { Loader } from "Shared/Common/Loader";
import NoRecord from "Shared/Common/NoRecord";
import useLang from "Shared/hooks/useLanguage";
interface Props {
  id: number;
}
const ExpandableRow: React.FC<Props> = ({ id }) => {
  const { t } = useLang();

  const [panelInfo, setPanelInfo] = useState<any>([]);
  const [loading, setLoading] = useState<any>([]);

  const loadData = () => {
    const payLoad = { requisitionOrderId: id };
    GetPartialRejectedOrdersById(payLoad).then((res: AxiosResponse) => {
      setPanelInfo(res?.data?.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="card shadow-sm mb-3 rounded border border-info">
      <div className="card-header d-flex justify-content-between align-items-center rounded bg-light-info min-h-35px">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
          <h6 className="text-info m-0">{t("Patient Test Result")}</h6>
        </div>
      </div>

      <div className="card-body py-md-4 py-3">
        <Box sx={{ height: "auto", width: "100%" }}>
          <div className="table_bordered overflow-hidden">
            <TableContainer
              sx={{
                maxHeight: "calc(100vh - 100px)",
                "&::-webkit-scrollbar": {
                  width: 7,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#fff",
                },
                "&:hover": {
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "var(--kt-gray-400)",
                    borderRadius: 2,
                  },
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "var(--kt-gray-400)",
                  borderRadius: 2,
                },
              }}
              component={Paper}
              className="shadow-none"
              // sx={{ maxHeight: 'calc(100vh - 100px)' }}
            >
              <Table
                stickyHeader
                aria-label="sticky table collapsible"
                className="table table-cutome-expend table-bordered table-head-bg table-bg table-head-custom table-vertical-center border-0 mb-0"
              >
                <TableHead className="h-35px">
                  <TableRow>
                    <TableCell>{t("Test Name")}</TableCell>
                    <TableCell>{t("Performing Lab")}</TableCell>
                    <TableCell>{t("Rejected Reason")}</TableCell>
                    <TableCell>{t("Specimen Type")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableCell colSpan={8} className="">
                      <Loader />
                    </TableCell>
                  ) : panelInfo?.length ? (
                    panelInfo?.map((item: any, index: any) => (
                      <TableRow key={index}>
                        {/* <TableCell className="text-center"> </TableCell> */}
                        <TableCell id={`ExpandDataPRT_${index + 1}`}>
                          {item?.testName}
                        </TableCell>
                        <TableCell id={`ExpandDataPRT_${index + 1}`}>
                          {item?.performingLab}
                        </TableCell>
                        <TableCell id={`ExpandDataPRT_${index + 1}`}>
                          {item?.rejectedReason}
                        </TableCell>
                        <TableCell id={`ExpandDataPRT_${index + 1}`}>
                          {item?.specimenType}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <NoRecord />
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Box>
      </div>
    </div>
  );
};
export default ExpandableRow;
